import styled from 'styled-components'
import { getDropdownContainerStyles } from '../style'

const DropdownContainer = styled.div`
    ${getDropdownContainerStyles}
`

export default DropdownContainer
